<section class="sb-smooch-alternative-container" [formGroup]="messageForm">
  <div>
    <div class="smooch-alternative-field-label">Conversation metadata</div>
    <textarea class="ds-textarea ds-textarea-black" formControlName="conversation_meta" rows="4"></textarea>
  </div>
  <div>
    <div class="smooch-alternative-field-label">Message metadata</div>
    <textarea class="ds-textarea ds-textarea-black" formControlName="message_meta" rows="4"></textarea>
  </div>
  <div>
    <div class="smooch-alternative-field-label">Message</div>
    <textarea [class.error]="messageForm.get('message').invalid" class="ds-textarea ds-textarea-black" formControlName="message" rows="4"></textarea>
  </div>
  <div class="sb-smooch-alternative-action-container">
    <button class="ds-btn-black"
            (click)="sendMessage()">
      Send
    </button>
  </div>
</section>
